const defaultStore = {
  searchParam: '',
  filterParam: [],
  sortParam: 'id1',
  order: 'desc',
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'SEARCH_VALUE':
      return {
        ...state,
        searchParam: action.searchParam,
      };

    case 'FILTER_VALUE':
      return {
        ...state,
        filterParam: action.filterParam,
      };

    case 'SORT_VALUE':
      return {
        ...state,
        sortParam: action.sortParam,
        order: action.order,
      };

    case 'CLEAR_SEARCH_PARAMS':
      return {
        ...state,
        searchParam: '',
        filterParam: [],
        sortParam: 'id1',
        order: 'desc',
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/searchParams.js